import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=31433f40&scoped=true&lang=pug&"
import script from "./ItemSelector.vue?vue&type=script&lang=ts&"
export * from "./ItemSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=31433f40&lang=scss&scoped=true&"
import style1 from "./ItemSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31433f40",
  null
  
)

export default component.exports